import { useContentCache, } from "@/entities"
import {
	contentControllerChangeTitle,
	type ChangeTitleDto,
} from "@/shared/api/generated"
import { useMutation } from "@tanstack/react-query"
import { useForm } from "react-hook-form"

type FormData = ChangeTitleDto
export function useRenameContentForm(
	id: string,
	title: string,
	closeModal: () => void
) {
	const contentCache = useContentCache()

	const { control, handleSubmit, watch } = useForm<FormData>({
		defaultValues: { id, title },
	})

	const titleValue = watch("title")

	const formMutation = useMutation({
		mutationFn: (data: ChangeTitleDto) => contentControllerChangeTitle(data),

	})

	return {
		control,
		handleSubmit: handleSubmit(async (values) => {

			await formMutation.mutateAsync(values)

			// TODO UPDATE TITLE FOR CURRENTLY PLAYING AUDIO IF IT'S THE SAME ID
			// if (listeningId === values.id) {
			// }
			closeModal()
			await contentCache.invalidateLibraryActivePage()

		}),
		titleValue,
		isLoading: formMutation.isPending,
	}
}
